import React from "react";

/**
 * Pill badge. Tone maps to a soft colour scheme (subtle in both themes).
 * tones: slate | primary | success | warning | danger | secondary
 */
const TONES = {
    slate: "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
    primary: "bg-primary-50 text-primary-700 ring-primary-100 dark:bg-primary-500/10 dark:text-primary-300 dark:ring-primary-500/20",
    success: "bg-success-50 text-success-700 ring-success-100 dark:bg-success-500/10 dark:text-success-400 dark:ring-success-500/20",
    warning: "bg-warning-50 text-warning-700 ring-warning-100 dark:bg-warning-500/10 dark:text-warning-400 dark:ring-warning-500/20",
    danger: "bg-danger-50 text-danger-700 ring-danger-100 dark:bg-danger-500/10 dark:text-danger-400 dark:ring-danger-500/20",
    secondary: "bg-secondary-50 text-secondary-700 ring-secondary-100 dark:bg-secondary-500/10 dark:text-secondary-300 dark:ring-secondary-500/20",
};

const SIZES = {
    sm: "px-2 py-0.5 text-[11px]",
    md: "px-2.5 py-1 text-xs",
};

export default function Badge({ children, tone = "slate", size = "md", dot = false, className = "", ...props }) {
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-full font-medium ring-1 ring-inset whitespace-nowrap
                ${TONES[tone] || TONES.slate} ${SIZES[size] || SIZES.md} ${className}`}
            {...props}
        >
            {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" />}
            {children}
        </span>
    );
}
